export const JIRA_SOFTWARE_FREE_IS_CCP_BILLING_ADMIN_TRAIT =
	'jira_software_free_is_ccp_billing_admins';
export const PACKAGE_NAME = 'jiraBilling';
